import React, { forwardRef } from 'react'; // Wichtig: forwardRef importieren
import './NavigationMenu.css';
import { Link as RouterLink } from 'react-router-dom';

// Die Komponente wird jetzt mit forwardRef umschlossen,
// um die Ref vom Elternteil (Header) empfangen zu können.
const NavigationMenu = forwardRef(({ isOpen, onClose, links = [] }, ref) => { // 'ref' hier als zweites Argument empfangen
  return (
    // Die empfangene Ref wird an das <nav>-Element angehängt,
    // damit der 'Click Outside'-Mechanismus korrekt funktioniert.
    <div id="navigation-menu" className={`navigation-menu ${isOpen ? 'open' : ''}`} ref={ref}>
      {/* Der Schließen-Button wurde wieder aktiviert */}
      <ul className="list-unstyled p-0 m-0">
        {/* Prüfe, ob Links vorhanden sind, bevor du mappt */}
        {links.length > 0 ? (
          links.map((link) => {
            // Destrukturierung der Link-Eigenschaften
            const { id, Name, Link: url, TextColorHexCode } = link;

            // Überspringe Links, die keinen Namen oder keine URL haben
            if (!Name || !url) return null;

            // Bestimme, ob es sich um einen internen Link handelt
            const isInternal = url.startsWith('/');
            // Erstelle den Zielpfad für interne Links
            const targetPath = `/Interact${url}`; // Wenn deine internen Pfade immer mit /Interact beginnen

            // Definiere den Stil für den Link
            const linkStyle = {
              color: TextColorHexCode || '#0d6efd', // Standardfarbe, falls keine TextColorHexCode vorhanden ist
            };

            return (
              <li key={id} className="mb-2">
                {isInternal ? (
                  // Verwende RouterLink für interne Pfade
                  <RouterLink
                    to={targetPath}
                    className="text-decoration-none"
                    style={linkStyle}
                    onClick={onClose} // Menü schließen, wenn ein Link geklickt wird
                  >
                    {Name}
                  </RouterLink>
                ) : (
                  // Verwende einen Standard-Anchor-Tag für externe URLs
                  <a
                    href={url}
                    className="text-decoration-none"
                    style={linkStyle}
                    onClick={onClose} // Menü schließen, wenn ein Link geklickt wird
                    target="_blank" // Öffne externe Links in einem neuen Tab
                    rel="noopener noreferrer" // Wichtig für Sicherheit bei target="_blank"
                  >
                    {Name}
                  </a>
                )}
              </li>
            );
          })
        ) : (
          // Optional: Fallback, wenn keine Links verfügbar sind
          <li><span className="text-white-50">Keine Navigationslinks verfügbar.</span></li>
        )}
      </ul>
    </div>
  );
});

export default NavigationMenu;